import React, { useContext, useState } from 'react'
import { FaTextWidth } from 'react-icons/fa'
import { EditorContext } from '../../../../../../../components/CanvasEditor/Context/EditorProvider';

const StrokeWidth = () => {

  const { textEditorOptions, setTextEditorOptions } = useContext(EditorContext);
  const [openTransform, setOpenTransform] = useState(false)

  const handleChange = (e) => {
    setTextEditorOptions({ ...textEditorOptions, strokeWidth: e.target.value });
  }

  return (
    <div className='editor-item transform'>
      <div className={`editor-icon ${openTransform ? 'active' : ''}`} onClick={e=> setOpenTransform(!openTransform)} data-toggle="tooltip" data-placement="top" title="Stroke Width">
        <FaTextWidth />
      </div>
      <div className={`transform-body ${openTransform ? '' : 'd-none'}`}>
        <div className='input-range'>
          <input type="range" class="custom-range" min={0} max={5} value={textEditorOptions.strokeWidth} onChange={handleChange} id="customRange1" />
        </div>
      </div>
    </div>
  )
}

export default StrokeWidth